let data;
export default data = [
    {
        url1:"https://www.jefit.com/images/exercises/800_600/3340.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/3341.jpg",
        info:{
                Title:"Assisted Chest Stretch",
                group:"Main Muscle Group : Chest",
                type:"Type : Stretching",
                equip:"Equipment : Body Only"

            },
        button:"View History",
        
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/3388.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/3389.jpg",
        info:{
                Title:"Back Stretch",
                group:"Main Muscle Group : Chest",
                type:"Type : Stretching",
                equip:"Equipment : Body Only"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/1480.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/1481.jpg",
        info:{
                Title:"Band Bench Press",
                group:"Main Muscle Group : Chest",
                type:"Type : Strength",
                equip:"Equipment : Bands, Bench"

            },
        button:"View History",
        
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/4.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/5.jpg",
        info:{
                Title:"Band Cross-Over",
                group:"Main Muscle Group : Chest",
                type:"Type : Strength",
                equip:"Equipment : Bands"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/8.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/9.jpg",
        info:{
                Title:"Barbell Bench Press",
                group:"Main Muscle Group : Chest",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/20.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/21.jpg",
        info:{
                Title:"Barbell Decline Bench Press",
                group:"Main Muscle Group : Chest",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/5308.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/5309.jpg",
        info:{
                Title:"Barbell Decline Pullover",
                group:"Main Muscle Group : Chest",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/648.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/649.jpg",
        info:{
                Title:"Barbell Front Raise Pullover",
                group:"Main Muscle Group : Chest",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    
    

]
